<template>
    <div class="corner absolute right-[-2%] bottom-[-2%] h-[40%] w-[50%] rotate-180 z-1">
      <img src="/assets/images/svg/blue corner.svg" alt="" />
      <img src="/assets/images/svg/pointed triangle.svg" alt="" />
      <img src="/assets/images/svg/blue edge.svg" alt="" />
    </div>
</template>